document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".animated-tunable .tunable-lighting-item");
  const header = document.querySelector("header");
  const threshold = 100;

  function updateAnimation() {
    let nearestItem = null;
    let minDistance = Infinity;

    items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const distance = Math.abs(rect.top - (header.offsetHeight + threshold));

      if (distance < minDistance) {
        minDistance = distance;
        nearestItem = item;
      }
    });

    // Remove class from all items
    items.forEach((item) => item.classList.remove("add-animation"));

    // Add class only to the nearest item
    if (nearestItem) {
      nearestItem.classList.add("add-animation");
    }
  }

  // Trigger on scroll
  window.addEventListener("scroll", updateAnimation);

  // Initial check on page load
  updateAnimation();
});
